import React, { JSX } from 'react'

const CartWhiteIcon: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.775 14.4418V5.09082H0.5V14.4418C0.499869 14.6469 0.540156 14.8499 0.618557 15.0393C0.696958 15.2288 0.811935 15.4009 0.956913 15.5459C1.10189 15.6909 1.27403 15.8059 1.46348 15.8843C1.65292 15.9627 1.85597 16.003 2.061 16.0028H11.215C11.4199 16.0028 11.6229 15.9624 11.8122 15.884C12.0015 15.8055 12.1736 15.6905 12.3184 15.5456C12.4633 15.4006 12.5782 15.2285 12.6565 15.0391C12.7349 14.8497 12.7751 14.6468 12.775 14.4418Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.07593 5.09101V3.04501C4.0758 2.776 4.12877 2.50961 4.2318 2.26111C4.33484 2.01261 4.48592 1.7869 4.67637 1.59691C4.86682 1.40692 5.0929 1.2564 5.34165 1.15397C5.5904 1.05154 5.85692 0.999219 6.12593 1.00001H7.14893C7.41757 0.999877 7.6836 1.05268 7.93182 1.15539C8.18005 1.2581 8.40561 1.40871 8.59561 1.59862C8.78561 1.78853 8.93633 2.01401 9.03917 2.26219C9.142 2.51037 9.19493 2.77637 9.19493 3.04501V5.09101"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CartWhiteIcon
